// common.ts
var common = {
  "android": {
    "additional_sha256_cert_fingerprints": [
      "46:B0:8A:B8:33:58:9C:BE:C4:FF:02:27:82:DF:B6:4A:36:B8:07:9B:DC:16:30:64:15:03:0B:28:E3:FF:9A:6E",
      "92:B7:40:E9:46:06:EB:75:62:DC:25:28:F3:E0:AC:09:ED:55:9C:8D:94:3D:CF:D0:81:2F:66:8C:2A:FF:AD:3C"
    ]
  },
  "external_link_patterns": [
    {
      "name": "firebase_auth",
      "effect": "allow",
      "action": null,
      "rules": [
        {
          "part": "path",
          "rule": "starts_with",
          "value": [
            "/__/"
          ]
        }
      ]
    },
    {
      "name": "google_recaptcha",
      "effect": "allow",
      "action": null,
      "rules": [
        {
          "part": "path",
          "rule": "starts_with",
          "value": [
            "/recaptcha/"
          ]
        },
        {
          "part": "host",
          "rule": "equals",
          "value": [
            "www.google.com"
          ]
        }
      ]
    },
    {
      "name": "other_protocols",
      "effect": "block",
      "action": "open_link",
      "rules": [
        {
          "part": "scheme",
          "rule": "equals",
          "value": [
            "tel:",
            "maps:",
            "mailto:",
            "sms:",
            "geo:"
          ]
        }
      ]
    },
    {
      "name": "block_blob",
      "effect": "block",
      "action": "notify_unsupported",
      "rules": [
        {
          "part": "scheme",
          "rule": "equals",
          "value": [
            "blob:"
          ]
        }
      ]
    }
  ]
};

// albertine.ts
var albertine = {
  "id": "albertine",
  "dev_port": 3001,
  "name": "Albertine",
  "short_name": "Albertine",
  "ios": {
    "app_project": {
      "target_name": "Albertine",
      "directory_name": "Albertine",
      "product_name": "Albertine",
      "localizations": [
        "en"
      ],
      "associated_domains": {
        "development": [
          "applinks:concierge-albertine.dev.albertineapp.com",
          "applinks:albertine-dev-concierge.firebaseapp.com"
        ],
        "staging": [
          "applinks:concierge-albertine.staging.albertineapp.com",
          "applinks:albertine-staging-concierge.firebaseapp.com"
        ],
        "production": [
          "applinks:concierge.albertineapp.com",
          "applinks:albertine-prod-concierge.firebaseapp.com"
        ]
      },
      "interface_style": "Light",
      "preview_app_url": "https://concierge.albertineapp.com/app",
      "sentry_project": null,
      "sentry_dsn": "https://3162b12071ed975ca94d795c421c5878@o4508766569824256.ingest.de.sentry.io/4511711158337616",
      "font_files": [
        "MintGroteskItalicV1.0-Black.otf",
        "MintGroteskItalicV1.0-Bold.otf",
        "MintGroteskItalicV1.0-ExtraBold.otf",
        "MintGroteskItalicV1.0-Heavy.otf",
        "MintGroteskItalicV1.0-Light.otf",
        "MintGroteskItalicV1.0-Medium.otf",
        "MintGroteskItalicV1.0-Regular.otf",
        "MintGroteskItalicV1.0-Thin.otf",
        "MintGroteskV1.0-Black.otf",
        "MintGroteskV1.0-Bold.otf",
        "MintGroteskV1.0-ExtraBold.otf",
        "MintGroteskV1.0-Heavy.otf",
        "MintGroteskV1.0-Light.otf",
        "MintGroteskV1.0-Medium.otf",
        "MintGroteskV1.0-Regular.otf",
        "MintGroteskV1.0-Thin.otf"
      ],
      "auth_issuer_overrides": {},
      "api_environment_overrides": {}
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.concierge-albertine"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.concierge-albertine",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753748145"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.concierge-albertine",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753678727"
    },
    "preview": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.albertineapp.preview",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6751585533"
    },
    "prod": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.albertineapp",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "1571919079"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "albertine",
      "product_name": "Albertine",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-albertine",
        "dsn": "https://6f0f7a91009214dd081b65210a2a3b6a@o4508766569824256.ingest.de.sentry.io/4511704429297744"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3001/app"
        ],
        "dev": [
          "https://concierge-albertine.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-albertine.staging.albertineapp.com/app"
        ],
        "prod": [
          "https://concierge.albertineapp.com/app"
        ]
      },
      "preview_base_url": null
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.concierge_albertine",
      "oidc_redirect_uri": "com.albertineapp.localhost://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.concierge_albertine",
      "oidc_redirect_uri": "com.albertineapp.dev://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.concierge_albertine",
      "oidc_redirect_uri": "com.albertineapp.staging://auth/callback"
    },
    "preview": null,
    "prod": {
      "unsigned": false,
      "app_id": "com.albertineapp.albertineapp",
      "oidc_redirect_uri": "com.albertineapp://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "36:72:2F:1D:14:97:EC:01:61:0D:5F:97:8B:57:79:4F:07:BA:86:46:9E:78:EB:2E:08:EA:D2:8D:9A:45:B3:6C",
      "90:52:A6:0E:41:E8:88:38:21:2C:45:31:E9:1F:8E:B8:3A:EF:78:06:36:35:9C:98:8D:C2:9E:6D:F5:BC:B0:0D",
      "FA:C6:17:45:DC:09:03:78:6F:B9:ED:E6:2A:96:2B:39:9F:73:48:F0:BB:6F:89:9B:83:32:66:75:91:03:3B:9C",
      "33:CF:ED:B7:76:C2:8F:5D:B0:92:C6:80:A8:E8:9D:99:9D:DA:CC:34:A6:DE:58:DD:0A:5E:A6:39:95:F9:10:12",
      "8E:A8:CB:A1:9E:23:D5:A4:BB:87:E2:99:80:5F:0B:1E:B4:C7:85:1E:F3:61:7A:A4:07:F7:DE:F1:BD:3E:EE:8D",
      "55:6B:6D:DE:96:BD:8D:08:0C:72:33:CA:B4:F2:91:6E:50:BD:B9:6E:35:47:11:C2:B1:05:02:24:14:73:77:EE"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3001/app/",
      "dev": "https://concierge-albertine.dev.albertineapp.com/app/",
      "staging": "https://concierge-albertine.staging.albertineapp.com/app/",
      "prod": "https://concierge.albertineapp.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "conciergelogindevelopment.page.link",
      "dev": "conciergelogindevelopment.page.link",
      "staging": "conciergeloginstaging.page.link",
      "prod": "conciergelogin.page.link"
    },
    "iosBundleId": "com.albertineapp.albertineapp",
    "tokenSignup": null
  },
  "allowedServiceLanguages": [
    "en"
  ],
  "htmlFavicon": "favicon-152.png",
  "serviceMarketingUrl": "https://albertineapp.com/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.concierge-albertine://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748145",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.concierge_albertine"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.concierge-albertine://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748145",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.concierge_albertine"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.concierge-albertine://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753678727",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.concierge_albertine"
    },
    "prod": {
      "iosDeepLink": [
        "albertineapp://",
        "com.albertineapp.albertineapp://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id1571919079",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.albertineapp"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3001/app/?openApp=true",
    "dev": "https://concierge-albertine.dev.albertineapp.com/app/?openApp=true",
    "staging": "https://concierge-albertine.staging.albertineapp.com/app/?openApp=true",
    "prod": "https://concierge.albertineapp.com/app/?openApp=true"
  },
  "emailService": "membership@albertineapp.com",
  "emailServiceName": "Albertine Concierge",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "concierge@albertineapp.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://concierge.albertineapp.com/app/privacy-policy",
      "fr": "https://concierge.albertineapp.com/app/privacy-policy?lang=fr",
      "de": "https://concierge.albertineapp.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://concierge.albertineapp.com/app/terms-and-conditions",
      "fr": "https://concierge.albertineapp.com/app/terms-and-conditions?lang=fr",
      "de": "https://concierge.albertineapp.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": null
  },
  "external_link_patterns": [
    {
      "name": "homepage",
      "effect": "block",
      "action": "open_browser_modal",
      "rules": [
        {
          "part": "host",
          "rule": "equals",
          "value": [
            "albertineapp.com",
            "www.albertine.com"
          ]
        }
      ]
    }
  ],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://europe-west1-albertine-dev.cloudfunctions.net/publicShare",
    "staging": "https://europe-west1-albertine-staging.cloudfunctions.net/publicShare",
    "prod": "https://concierge.albertineapp.com/"
  },
  "host_name": {
    "localhost": "localhost:3001",
    "dev": "concierge-albertine.dev.albertineapp.com",
    "staging": "concierge-albertine.staging.albertineapp.com",
    "prod": "concierge.albertineapp.com"
  },
  "production_domains": [
    "concierge.albertineapp.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3001",
    "dev": "albertine-dev-concierge.firebaseapp.com",
    "staging": "albertine-staging-concierge.firebaseapp.com",
    "prod": "albertine-prod-concierge.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Albertine",
    "trialsEnabled": true
  }
};

// hugoboss.ts
var hugoboss = {
  "id": "hugoboss",
  "dev_port": 3002,
  "name": "Concierge HUGO BOSS",
  "short_name": "Concierge",
  "ios": {
    "app_project": {
      "target_name": "HugoBoss",
      "directory_name": "Hugo Boss",
      "product_name": "Concierge",
      "localizations": [
        "en",
        "de",
        "fr"
      ],
      "associated_domains": {
        "development": [
          "applinks:concierge-hugoboss.dev.albertineapp.com",
          "applinks:albertine-dev-concierge-hugoboss.firebaseapp.com"
        ],
        "staging": [
          "applinks:concierge-hugoboss.staging.albertineapp.com",
          "applinks:albertine-staging-concierge-hugoboss.firebaseapp.com"
        ],
        "production": [
          "applinks:concierge.hugoboss.com",
          "applinks:albertine-prod-concierge-hugoboss.firebaseapp.com"
        ]
      },
      "interface_style": "Dark",
      "preview_app_url": "https://concierge.hugoboss.com/app",
      "sentry_project": null,
      "sentry_dsn": "https://cf02da17653f88d4b3837d047afef1f9@o4508766569824256.ingest.de.sentry.io/4511711164039248",
      "font_files": [
        "AvertaPE-Bold.otf",
        "AvertaPE-Extrabold.otf",
        "AvertaPE-Light.otf",
        "AvertaPE-LightItalic.otf",
        "AvertaPE-Regular.otf",
        "AvertaPE-RegularItalic.otf"
      ],
      "auth_issuer_overrides": {},
      "api_environment_overrides": {}
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.concierge-hugoboss"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.concierge-hugoboss",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753748236"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.concierge-hugoboss",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753679627"
    },
    "preview": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.preview.concierge-hugoboss",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6757698886"
    },
    "prod": {
      "unsigned": false,
      "bundle_id": "com.hugoboss.hugoboss-concierge",
      "apple_team_id": "Q53HYY8W4N",
      "asc_app_id": "6736383588"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "hugoboss",
      "product_name": "Hugo Boss Concierge",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-hugoboss",
        "dsn": "https://f24a2ff322887bfefc2643ab61dc9fb0@o4508766569824256.ingest.de.sentry.io/4511710526308432"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3002/app"
        ],
        "dev": [
          "https://concierge-hugoboss.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-hugoboss.staging.albertineapp.com/app"
        ],
        "prod": [
          "https://concierge.hugoboss.com/app"
        ]
      },
      "preview_base_url": null
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.concierge_hugoboss",
      "oidc_redirect_uri": "com.albertineapp.concierge-hugoboss.localhost://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.concierge_hugoboss",
      "oidc_redirect_uri": "com.albertineapp.concierge-hugoboss.dev://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.concierge_hugoboss",
      "oidc_redirect_uri": "com.albertineapp.concierge-hugoboss.staging://auth/callback"
    },
    "preview": null,
    "prod": {
      "unsigned": false,
      "app_id": "com.hugoboss.concierge",
      "oidc_redirect_uri": "com.hugoboss.concierge://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "DD:2C:DF:D3:7D:BC:EA:C3:93:F5:48:9F:80:5D:16:36:6B:C5:34:C9:96:8F:21:61:13:FF:D0:95:70:DB:66:1E",
      "7E:5A:E2:A5:7D:45:C3:F8:87:D9:63:1E:51:4D:07:89:2E:AF:F0:C2:EE:85:F4:53:66:1C:16:38:E2:19:FF:E6",
      "79:3B:0F:B7:E5:83:8D:31:45:50:FB:70:10:18:5F:67:22:47:97:62:7F:CD:7A:D4:23:5A:66:EB:77:4E:AD:EC",
      "CF:90:12:5D:2D:F8:62:66:EB:30:88:5D:C3:DE:74:15:1D:75:DF:8C:46:76:E9:90:DD:7E:3C:49:9B:7C:BB:87",
      "90:52:A6:0E:41:E8:88:38:21:2C:45:31:E9:1F:8E:B8:3A:EF:78:06:36:35:9C:98:8D:C2:9E:6D:F5:BC:B0:0D",
      "92:B7:40:E9:46:06:EB:75:62:DC:25:28:F3:E0:AC:09:ED:55:9C:8D:94:3D:CF:D0:81:2F:66:8C:2A:FF:AD:3C"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3002/app/",
      "dev": "https://concierge-hugoboss.dev.albertineapp.com/app/",
      "staging": "https://concierge-hugoboss.staging.albertineapp.com/app/",
      "prod": "https://concierge.hugoboss.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "conciergelogindevelopment.page.link",
      "dev": "conciergelogindevelopment.page.link",
      "staging": "conciergeloginstaging.page.link",
      "prod": "conciergelogin.page.link"
    },
    "iosBundleId": "com.hugoboss.hugoboss-concierge",
    "tokenSignup": null
  },
  "allowedServiceLanguages": [
    "en",
    "de",
    "fr"
  ],
  "htmlFavicon": "favicon-512-hb.png",
  "serviceMarketingUrl": "https://www.hugoboss.com/uk/hugoboss-xp/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.concierge-hugoboss://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748236",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.concierge_hugoboss"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.concierge-hugoboss://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748236",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.concierge_hugoboss"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.concierge-hugoboss://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753679627",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.concierge_hugoboss"
    },
    "prod": {
      "iosDeepLink": [
        "hugoboss-concierge://",
        "com.hugoboss.hugoboss-concierge://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6736383588",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.hugoboss.concierge"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3002/app/?openApp=true",
    "dev": "https://concierge-hugoboss.dev.albertineapp.com/app/?openApp=true",
    "staging": "https://concierge-hugoboss.staging.albertineapp.com/app/?openApp=true",
    "prod": "https://concierge.hugoboss.com/app/?openApp=true"
  },
  "emailService": "info@concierge.hugoboss.com",
  "emailServiceName": "Hugo Boss XP Concierge",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "info@concierge.hugoboss.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://concierge.hugoboss.com/app/privacy-policy",
      "fr": "https://concierge.hugoboss.com/app/privacy-policy?lang=fr",
      "de": "https://concierge.hugoboss.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://concierge.hugoboss.com/app/terms-and-conditions",
      "fr": "https://concierge.hugoboss.com/app/terms-and-conditions?lang=fr",
      "de": "https://concierge.hugoboss.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": null
  },
  "external_link_patterns": [],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://europe-west1-albertine-dev.cloudfunctions.net/publicShare",
    "staging": "https://europe-west1-albertine-staging.cloudfunctions.net/publicShare",
    "prod": "https://concierge.hugoboss.com/"
  },
  "host_name": {
    "localhost": "localhost:3002",
    "dev": "concierge-hugoboss.dev.albertineapp.com",
    "staging": "concierge-hugoboss.staging.albertineapp.com",
    "prod": "concierge.hugoboss.com"
  },
  "production_domains": [
    "concierge.hugoboss.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3002",
    "dev": "albertine-dev-concierge-hugoboss.firebaseapp.com",
    "staging": "albertine-staging-concierge-hugoboss.firebaseapp.com",
    "prod": "albertine-prod-concierge-hugoboss.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Hugo Boss",
    "trialsEnabled": false
  }
};

// mastercard.ts
var mastercard = {
  "id": "mastercard",
  "dev_port": 3003,
  "name": "Mastercard Digital Concierge",
  "short_name": "Concierge",
  "ios": {
    "app_project": {
      "target_name": "Mastercard",
      "directory_name": "Mastercard",
      "product_name": "Concierge",
      "localizations": [
        "en",
        "de"
      ],
      "associated_domains": {
        "development": [
          "applinks:concierge-mastercard.dev.albertineapp.com",
          "applinks:albertine-dev-concierge-mastercard.firebaseapp.com"
        ],
        "staging": [
          "applinks:concierge-mastercard.staging.albertineapp.com",
          "applinks:albertine-staging-concierge-mastercard.firebaseapp.com"
        ],
        "production": [
          "applinks:digitalconcierge.mastercard.com",
          "applinks:albertine-prod-concierge-mastercard.firebaseapp.com"
        ]
      },
      "interface_style": "Dark",
      "preview_app_url": "https://concierge-mastercard.staging.albertineapp.com/app",
      "sentry_project": null,
      "sentry_dsn": "https://2699d79a0c05e45908c0546650760f5c@o4508766569824256.ingest.de.sentry.io/4511711165743184",
      "font_files": [
        "MarkWebPro-Regular.ttf",
        "MarkWebPro-Italic.ttf",
        "MarkWebPro-Book.ttf",
        "MarkWebPro-BookItalic.ttf",
        "MarkWebPro-MediumItalic.ttf",
        "MarkWebPro-Medium.ttf",
        "MarkWebPro-Bold.ttf",
        "MarkWebPro-BoldItalic.ttf"
      ],
      "auth_issuer_overrides": {},
      "api_environment_overrides": {
        "preview": "staging"
      }
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.concierge-mastercard"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.concierge-mastercard",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753748558"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.concierge-mastercard",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6753678820"
    },
    "preview": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.preview.concierge-mastercard",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6754242438"
    },
    "prod": {
      "unsigned": true,
      "bundle_id": "com.mastercard.digitalconcierge",
      "apple_team_id": "QJJJ72YP26",
      "asc_app_id": "6753317647"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "mastercard",
      "product_name": "Concierge",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "preview",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-mastercard",
        "dsn": "https://c17f2cca48f3932581a386c9a444f18a@o4508766569824256.ingest.de.sentry.io/4511710530043984"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3003/app"
        ],
        "dev": [
          "https://concierge-mastercard.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-mastercard.staging.albertineapp.com/app"
        ],
        "preview": [
          "https://concierge-mastercard.staging.albertineapp.com/app"
        ],
        "prod": [
          "https://digitalconcierge.mastercard.com/app"
        ]
      },
      "preview_base_url": "https://concierge-mastercard.staging.albertineapp.com/"
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.concierge_mastercard",
      "oidc_redirect_uri": "com.albertineapp.mastercard.localhost://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.concierge_mastercard",
      "oidc_redirect_uri": "com.albertineapp.mastercard.dev://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.concierge_mastercard",
      "oidc_redirect_uri": "com.albertineapp.mastercard.staging://auth/callback"
    },
    "preview": {
      "unsigned": false,
      "app_id": "com.albertineapp.preview.concierge_mastercard",
      "oidc_redirect_uri": "com.albertineapp.mastercard.preview://auth/callback"
    },
    "prod": {
      "unsigned": true,
      "app_id": "com.mastercard.digitalconcierge",
      "oidc_redirect_uri": "com.mastercard.digitalconcierge://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "57:59:FC:09:00:4B:C1:F3:6F:FB:EA:ED:3C:FC:19:EC:B8:CA:65:E1:D2:DA:89:71:62:B0:C2:2A:AE:58:FE:73",
      "CB:D7:52:8F:F9:27:1E:6E:7C:44:46:7C:65:68:78:D3:8E:33:20:C1:A7:BF:18:57:B0:4A:99:12:13:A1:52:99",
      "88:D4:DA:20:BB:69:70:A4:CE:42:61:72:D0:A3:F4:28:09:D9:1A:DF:82:DF:38:37:18:D2:EF:0B:7B:AB:BA:DF",
      "AB:C5:AD:4F:58:AE:ED:67:43:64:A5:DE:1A:99:F6:43:B6:E4:E1:A0:3D:DC:B6:F7:8E:53:A9:54:BF:D9:A1:56",
      "92:B7:40:E9:46:06:EB:75:62:DC:25:28:F3:E0:AC:09:ED:55:9C:8D:94:3D:CF:D0:81:2F:66:8C:2A:FF:AD:3C"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3003/app/",
      "dev": "https://concierge-mastercard.dev.albertineapp.com/app/",
      "staging": "https://concierge-mastercard.staging.albertineapp.com/app/",
      "prod": "https://digitalconcierge.mastercard.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "conciergelogindevelopment.page.link",
      "dev": "conciergelogindevelopment.page.link",
      "staging": "conciergeloginstaging.page.link",
      "prod": "conciergelogin.page.link"
    },
    "iosBundleId": "com.mastercard.digitalconcierge",
    "tokenSignup": {
      "membershipTierId": "mastercard"
    }
  },
  "allowedServiceLanguages": [
    "en",
    "de"
  ],
  "htmlFavicon": "favicon-152.png",
  "serviceMarketingUrl": "https://digitalconcierge.mastercard.com/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.concierge-mastercard://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748558",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.concierge_mastercard"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.concierge-mastercard://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753748558",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.concierge_mastercard"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.concierge-mastercard://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753678820",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.concierge_mastercard"
    },
    "prod": {
      "iosDeepLink": [
        "mastercard-digitalconcierge://",
        "com.mastercard.digitalconcierge://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6753317647",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.mastercard.digitalconcierge"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3003/app/?openApp=true",
    "dev": "https://concierge-mastercard.dev.albertineapp.com/app/?openApp=true",
    "staging": "https://concierge-mastercard.staging.albertineapp.com/app/?openApp=true",
    "prod": "https://digitalconcierge.mastercard.com/app/?openApp=true"
  },
  "emailService": "info@digitalconcierge.mastercard.com",
  "emailServiceName": "Mastercard Digital Concierge",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "info@digitalconcierge.mastercard.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://digitalconcierge.mastercard.com/app/privacy-policy",
      "fr": "https://digitalconcierge.mastercard.com/app/privacy-policy?lang=fr",
      "de": "https://digitalconcierge.mastercard.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://digitalconcierge.mastercard.com/app/terms-and-conditions",
      "fr": "https://digitalconcierge.mastercard.com/app/terms-and-conditions?lang=fr",
      "de": "https://digitalconcierge.mastercard.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": {
      "en": "https://www.mastercard.com/us/en/global-privacy-notice.html",
      "fr": "https://www.mastercard.com/us/en/global-privacy-notice.html",
      "de": "https://www.mastercard.com/us/en/global-privacy-notice.html"
    }
  },
  "external_link_patterns": [
    {
      "name": "mastercard_search-benefits_iframe",
      "effect": "allow",
      "action": null,
      "rules": [
        {
          "part": "host",
          "rule": "equals",
          "value": [
            "mtf.benefits.mastercard.com",
            "dev.benefits.mastercard.com",
            "stage.benefits.mastercard.com",
            "benefits.mastercard.com"
          ]
        }
      ]
    }
  ],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://europe-west1-albertine-dev.cloudfunctions.net/publicShare",
    "staging": "https://europe-west1-albertine-staging.cloudfunctions.net/publicShare",
    "prod": "https://digitalconcierge.mastercard.com/"
  },
  "host_name": {
    "localhost": "localhost:3003",
    "dev": "concierge-mastercard.dev.albertineapp.com",
    "staging": "concierge-mastercard.staging.albertineapp.com",
    "prod": "digitalconcierge.mastercard.com"
  },
  "production_domains": [
    "digitalconcierge.mastercard.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3003",
    "dev": "albertine-dev-concierge-mastercard.firebaseapp.com",
    "staging": "albertine-staging-concierge-mastercard.firebaseapp.com",
    "prod": "albertine-prod-concierge-mastercard.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Mastercard",
    "trialsEnabled": false
  }
};

// carlo.ts
var carlo = {
  "id": "carlo",
  "dev_port": 3004,
  "name": "Carl Concierge",
  "short_name": "Concierge",
  "ios": {
    "app_project": {
      "target_name": "Carlo",
      "directory_name": "Carlo",
      "product_name": "Carl",
      "localizations": [
        "en",
        "fr"
      ],
      "associated_domains": {
        "development": [
          "applinks:concierge-carlo.dev.albertineapp.com"
        ],
        "staging": [
          "applinks:concierge-carlo.staging.albertineapp.com"
        ],
        "production": [
          "applinks:carlinmonaco.com",
          "applinks:www.carlinmonaco.com"
        ]
      },
      "interface_style": "Light",
      "preview_app_url": "https://www.carlinmonaco.com/app",
      "sentry_project": null,
      "sentry_dsn": "https://0328b3ead7fe1eecff17ed9a9a0531c0@o4508766569824256.ingest.de.sentry.io/4511711162269776",
      "font_files": [
        "Fraunces_72pt-Light.ttf",
        "Fraunces_72pt-Bold.ttf"
      ],
      "auth_issuer_overrides": {
        "preview": "https://concierge.albertineapp.com/auth/realms/carlo",
        "prod": "https://carlinmonaco.com/auth/realms/carlo"
      },
      "api_environment_overrides": {}
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.concierge-carlo"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.concierge-carlo",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6780794011"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.concierge-carlo",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6780794054"
    },
    "preview": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.preview.concierge-carlo",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6780794331"
    },
    "prod": {
      "unsigned": false,
      "bundle_id": "com.carlotechnologies.carl",
      "apple_team_id": "9AQ3SFG5PP",
      "asc_app_id": "6782862878"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "carlo",
      "product_name": "Carl",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-carlo",
        "dsn": "https://21be96d7f416f3f618ccb26610f55128@o4508766569824256.ingest.de.sentry.io/4511710519951440"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3004/app"
        ],
        "dev": [
          "https://concierge-carlo.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-carlo.staging.albertineapp.com/app"
        ],
        "prod": [
          "https://www.carlinmonaco.com/app"
        ]
      },
      "preview_base_url": null
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.concierge_carlo",
      "oidc_redirect_uri": "com.albertineapp.localhost.concierge-carlo://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.concierge_carlo",
      "oidc_redirect_uri": "com.albertineapp.dev.concierge-carlo://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.concierge_carlo",
      "oidc_redirect_uri": "com.albertineapp.staging.concierge-carlo://auth/callback"
    },
    "preview": {
      "unsigned": false,
      "app_id": "com.albertineapp.preview.concierge_carlo",
      "oidc_redirect_uri": null
    },
    "prod": {
      "unsigned": false,
      "app_id": "com.carlotechnologies.carl",
      "oidc_redirect_uri": "com.carlotechnologies.carl://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "AB:25:63:5A:CB:7B:98:48:BB:6B:87:03:3D:16:0D:B3:60:61:76:4D:64:31:52:51:4F:48:F4:74:00:D1:5B:FB",
      "D5:9F:C8:B0:82:D4:70:38:FE:04:1C:42:49:92:6A:F4:C7:B5:D3:BE:D1:CC:0D:98:B6:71:35:C5:AD:8A:D5:9E",
      "09:CD:ED:6A:3E:3F:E8:25:23:91:E2:DE:1F:36:C7:3E:E4:C8:82:31:F9:E2:78:51:30:25:CC:98:91:24:B0:F9"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3004/app/",
      "dev": "https://concierge-carlo.dev.albertineapp.com/app/",
      "staging": "https://concierge-carlo.staging.albertineapp.com/app/",
      "prod": "https://www.carlinmonaco.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "DEPRECATED",
      "dev": "DEPRECATED",
      "staging": "DEPRECATED",
      "prod": "DEPRECATED"
    },
    "iosBundleId": "com.carlotechnologies.carl",
    "tokenSignup": {
      "membershipTierId": "carlo"
    }
  },
  "allowedServiceLanguages": [
    "en",
    "fr"
  ],
  "htmlFavicon": "favicon-152.png",
  "serviceMarketingUrl": "https://www.carlinmonaco.com/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.concierge-carlo://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6780794011",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.concierge_carlo"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.concierge-carlo://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6780794011",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.concierge_carlo"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.concierge-carlo://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6780794054",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.concierge_carlo"
    },
    "prod": {
      "iosDeepLink": [
        "com.carlotechnologies.carl://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6782862878",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.carlotechnologies.carl"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3004/app/?openApp=true",
    "dev": "https://www.carlinmonaco.com/app/?openApp=true",
    "staging": "https://www.carlinmonaco.com/app/?openApp=true",
    "prod": "https://www.carlinmonaco.com/app/?openApp=true"
  },
  "emailService": "hello@carlinmonaco.com",
  "emailServiceName": "Carl Concierge",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "hello@carlinmonaco.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://www.carlinmonaco.com/app/privacy-policy",
      "fr": "https://www.carlinmonaco.com/app/privacy-policy?lang=fr",
      "de": "https://www.carlinmonaco.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://www.carlinmonaco.com/app/terms-and-conditions",
      "fr": "https://www.carlinmonaco.com/app/terms-and-conditions?lang=fr",
      "de": "https://www.carlinmonaco.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": null
  },
  "external_link_patterns": [],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://concierge-carlo.dev.albertineapp.com/",
    "staging": "https://concierge-carlo.staging.albertineapp.com/",
    "prod": "https://www.carlinmonaco.com/"
  },
  "host_name": {
    "localhost": "localhost:3004",
    "dev": "concierge-carlo.dev.albertineapp.com",
    "staging": "concierge-carlo.staging.albertineapp.com",
    "prod": "www.carlinmonaco.com"
  },
  "production_domains": [
    "www.carlinmonaco.com",
    "carlinmonaco.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3004",
    "dev": "albertine-dev-concierge-carlo.firebaseapp.com",
    "staging": "albertine-staging-concierge-carlo.firebaseapp.com",
    "prod": "albertine-prod-concierge-carlo.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Carlo",
    "trialsEnabled": true
  }
};

// visa-i2.ts
var visaI2 = {
  "id": "visa-i2",
  "dev_port": 3005,
  "name": "Infinite Private Concierge by Albertine",
  "short_name": "Concierge",
  "ios": {
    "app_project": {
      "target_name": "InfinitePrivate",
      "directory_name": "Infinite Private",
      "product_name": "Concierge",
      "localizations": [
        "en",
        "de",
        "fr"
      ],
      "associated_domains": {
        "development": [
          "applinks:concierge-visa-i2.dev.albertineapp.com"
        ],
        "staging": [
          "applinks:concierge-visa-i2.staging.albertineapp.com"
        ],
        "production": [
          "applinks:infiniteprivate.albertineapp.com"
        ]
      },
      "interface_style": "Light",
      "preview_app_url": "https://infiniteprivate.albertineapp.com/app",
      "sentry_project": "ios-visa-i2",
      "sentry_dsn": "https://11ec63cd46fc0725f85ef03657b7f7fd@o4508766569824256.ingest.de.sentry.io/4512130248278111",
      "font_files": [
        "VisaSans-Light.ttf",
        "VisaSans-Regular.ttf"
      ],
      "auth_issuer_overrides": {},
      "api_environment_overrides": {}
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.infiniteprivate"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.infiniteprivate",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6815676464"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.infiniteprivate",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6815676983"
    },
    "preview": {
      "unsigned": true,
      "bundle_id": "com.albertineapp.preview.infiniteprivate",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": null
    },
    "prod": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.infiniteprivate",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6815675295"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "infiniteprivate",
      "product_name": "Concierge",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "preview",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-visa-i2",
        "dsn": "https://3d0202fb9661917da72980440d41bd1e@o4508766569824256.ingest.de.sentry.io/4512130248343633"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3005/app"
        ],
        "dev": [
          "https://concierge-visa-i2.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-visa-i2.staging.albertineapp.com/app"
        ],
        "preview": [
          "https://infiniteprivate.albertineapp.com/app"
        ],
        "prod": [
          "https://infiniteprivate.albertineapp.com/app"
        ]
      },
      "preview_base_url": "https://infiniteprivate.albertineapp.com/"
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.infiniteprivate",
      "oidc_redirect_uri": "com.albertineapp.localhost.infiniteprivate://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.infiniteprivate",
      "oidc_redirect_uri": "com.albertineapp.dev.infiniteprivate://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.infiniteprivate",
      "oidc_redirect_uri": "com.albertineapp.staging.infiniteprivate://auth/callback"
    },
    "preview": {
      "unsigned": true,
      "app_id": "com.albertineapp.preview.infiniteprivate",
      "oidc_redirect_uri": "com.albertineapp.preview.infiniteprivate://auth/callback"
    },
    "prod": {
      "unsigned": false,
      "app_id": "com.albertineapp.infiniteprivate",
      "oidc_redirect_uri": "com.albertineapp.infiniteprivate://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "BC:C5:5C:28:42:63:6F:EB:CD:F5:86:AF:97:BE:3E:23:EA:A4:92:DC:08:88:76:8D:EC:C7:2A:DF:BE:AB:90:04",
      "F0:71:C5:4F:3F:E0:8E:3B:F0:3F:13:A3:1A:0B:0F:0A:97:B2:64:5E:61:96:E0:7F:2F:53:03:6B:E6:93:57:AF",
      "AA:3F:E6:3B:8B:0C:13:16:7B:AB:94:77:9E:C0:01:16:BE:95:C3:92:8F:E8:1C:4D:25:1F:15:24:DA:CD:E1:95"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3005/app/",
      "dev": "https://concierge-visa-i2.dev.albertineapp.com/app/",
      "staging": "https://concierge-visa-i2.staging.albertineapp.com/app/",
      "prod": "https://infiniteprivate.albertineapp.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "DEPRECATED",
      "dev": "DEPRECATED",
      "staging": "DEPRECATED",
      "prod": "DEPRECATED"
    },
    "iosBundleId": "com.albertineapp.infiniteprivate",
    "tokenSignup": {
      "membershipTierId": "visa-i2"
    }
  },
  "allowedServiceLanguages": [
    "en",
    "de",
    "fr"
  ],
  "htmlFavicon": "favicon-512-visa-i2.png",
  "serviceMarketingUrl": "https://infiniteprivate.albertineapp.com/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.infiniteprivate://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/idTODO",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.infiniteprivate"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.infiniteprivate://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/idTODO",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.infiniteprivate"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.infiniteprivate://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/idTODO",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.infiniteprivate"
    },
    "prod": {
      "iosDeepLink": [
        "com.albertineapp.infiniteprivate://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/idTODO",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.infiniteprivate"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3005/app/?openApp=true",
    "dev": "https://concierge-visa-i2.dev.albertineapp.com/app/?openApp=true",
    "staging": "https://concierge-visa-i2.staging.albertineapp.com/app/?openApp=true",
    "prod": "https://infiniteprivate.albertineapp.com/app/?openApp=true"
  },
  "emailService": "infiniteprivate@albertineapp.com",
  "emailServiceName": "Infinite Private Concierge by Albertine",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "infiniteprivate@albertineapp.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://infiniteprivate.albertineapp.com/app/privacy-policy",
      "fr": "https://infiniteprivate.albertineapp.com/app/privacy-policy?lang=fr",
      "de": "https://infiniteprivate.albertineapp.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://infiniteprivate.albertineapp.com/app/terms-and-conditions",
      "fr": "https://infiniteprivate.albertineapp.com/app/terms-and-conditions?lang=fr",
      "de": "https://infiniteprivate.albertineapp.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": null
  },
  "external_link_patterns": [],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://concierge-visa-i2.dev.albertineapp.com/",
    "staging": "https://concierge-visa-i2.staging.albertineapp.com/",
    "prod": "https://infiniteprivate.albertineapp.com/"
  },
  "host_name": {
    "localhost": "localhost:3005",
    "dev": "concierge-visa-i2.dev.albertineapp.com",
    "staging": "concierge-visa-i2.staging.albertineapp.com",
    "prod": "infiniteprivate.albertineapp.com"
  },
  "production_domains": [
    "infiniteprivate.albertineapp.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3005",
    "dev": "albertine-dev-concierge-visa-i2.firebaseapp.com",
    "staging": "albertine-staging-concierge-visa-i2.firebaseapp.com",
    "prod": "albertine-prod-concierge-visa-i2.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Visa i2",
    "trialsEnabled": false
  }
};

// revolut.ts
var revolut = {
  "id": "revolut",
  "dev_port": 3006,
  "name": "Albertine for Revolut",
  "short_name": "Concierge",
  "ios": {
    "app_project": {
      "target_name": "Revolut",
      "directory_name": "Revolut",
      "product_name": "Albertine for Revolut",
      "localizations": [
        "en"
      ],
      "associated_domains": {
        "development": [
          "applinks:revolut.dev.albertineapp.com",
          "applinks:albertine-dev-revolut.firebaseapp.com"
        ],
        "staging": [
          "applinks:revolut.staging.albertineapp.com",
          "applinks:albertine-staging-revolut.firebaseapp.com"
        ],
        "production": [
          "applinks:revolut.albertineapp.com",
          "applinks:albertine-prod-revolut.firebaseapp.com"
        ]
      },
      "interface_style": "Dark",
      "preview_app_url": "https://revolut.albertineapp.com/app",
      "sentry_project": null,
      "sentry_dsn": "https://cf02da17653f88d4b3837d047afef1f9@o4508766569824256.ingest.de.sentry.io/4512284252176464",
      "font_files": [
        "AvertaPE-Bold.otf",
        "AvertaPE-Extrabold.otf",
        "AvertaPE-Light.otf",
        "AvertaPE-LightItalic.otf",
        "AvertaPE-Regular.otf",
        "AvertaPE-RegularItalic.otf"
      ],
      "auth_issuer_overrides": {},
      "api_environment_overrides": {}
    },
    "localhost": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.localhost.revolut"
    },
    "dev": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.dev.revolut",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6825289870"
    },
    "staging": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.staging.revolut",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6825290805"
    },
    "preview": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.preview.revolut",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6751585533"
    },
    "prod": {
      "unsigned": false,
      "bundle_id": "com.albertineapp.revolut",
      "apple_team_id": "4HYQ3GYD6S",
      "asc_app_id": "6825233037"
    }
  },
  "android": {
    "app_project": {
      "source_set_name": "revolut",
      "product_name": "Albertine for Revolut",
      "enabled_environments": [
        "localhost",
        "dev",
        "staging",
        "prod"
      ],
      "sentry": {
        "org": "albertine",
        "project": "android-revolut",
        "dsn": "https://6f0f7a91009214dd081b65210a2a3b6a@o4508766569824256.ingest.de.sentry.io/4512284252242000"
      },
      "app_links": {
        "localhost": [
          "http://10.0.2.2:3006/app"
        ],
        "dev": [
          "https://concierge-revolut.dev.albertineapp.com/app"
        ],
        "staging": [
          "https://concierge-revolut.staging.albertineapp.com/app"
        ],
        "prod": [
          "https://revolut.albertineapp.com/app"
        ]
      },
      "preview_base_url": null
    },
    "localhost": {
      "unsigned": false,
      "app_id": "com.albertineapp.localhost.revolut",
      "oidc_redirect_uri": "com.albertineapp.localhost.revolut://auth/callback"
    },
    "dev": {
      "unsigned": false,
      "app_id": "com.albertineapp.dev.revolut",
      "oidc_redirect_uri": "com.albertineapp.dev.revolut://auth/callback"
    },
    "staging": {
      "unsigned": false,
      "app_id": "com.albertineapp.staging.revolut",
      "oidc_redirect_uri": "com.albertineapp.staging.revolut://auth/callback"
    },
    "preview": null,
    "prod": {
      "unsigned": false,
      "app_id": "com.albertineapp.revolut",
      "oidc_redirect_uri": "com.albertineapp.revolut://auth/callback"
    },
    "sha256_cert_fingerprints": [
      "50:4A:E6:0C:33:B2:25:48:46:DD:3C:BF:79:08:26:18:CB:FC:97:44:5F:42:58:04:40:6A:63:2B:E3:F3:DA:08",
      "26:0C:9C:B0:CF:BA:D6:4F:07:12:0D:C8:A9:F1:D7:20:9E:07:FD:16:F5:94:21:02:8C:95:1A:02:4A:FC:8A:E9",
      "C7:73:BB:72:3F:70:B2:79:9E:59:77:56:D7:FE:14:4C:49:EB:9A:4A:C2:E7:5E:02:DB:A6:6D:36:A3:A1:B5:86"
    ]
  },
  "authentication": {
    "webUrl": {
      "localhost": "http://localhost:3006/app/",
      "dev": "https://concierge-revolut.dev.albertineapp.com/app/",
      "staging": "https://concierge-revolut.staging.albertineapp.com/app/",
      "prod": "https://revolut.albertineapp.com/app/"
    },
    "iosLinkDomain": {
      "localhost": "DEPRECATED",
      "dev": "DEPRECATED",
      "staging": "DEPRECATED",
      "prod": "DEPRECATED"
    },
    "iosBundleId": "com.albertineapp.revolut",
    "tokenSignup": {
      "membershipTierId": "revolut"
    }
  },
  "allowedServiceLanguages": [
    "en"
  ],
  "htmlFavicon": "favicon-152.png",
  "serviceMarketingUrl": "https://albertineapp.com/",
  "openAppConfig": {
    "localhost": {
      "iosDeepLink": [
        "com.albertineapp.localhost.revolut://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6825289870",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.localhost.revolut"
    },
    "dev": {
      "iosDeepLink": [
        "com.albertineapp.dev.revolut://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6825289870",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.dev.revolut"
    },
    "staging": {
      "iosDeepLink": [
        "com.albertineapp.staging.revolut://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6825290805",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.staging.revolut"
    },
    "prod": {
      "iosDeepLink": [
        "com.albertineapp.revolut://"
      ],
      "iosFallbackUrl": "https://apps.apple.com/app/id6825233037",
      "androidFallbackUrl": "https://play.google.com/store/apps/details?id=com.albertineapp.revolut"
    }
  },
  "emailOpenAppLink": {
    "localhost": "http://localhost:3006/app/?openApp=true",
    "dev": "https://concierge-revolut.dev.albertineapp.com/app/?openApp=true",
    "staging": "https://concierge-revolut.staging.albertineapp.com/app/?openApp=true",
    "prod": "https://revolut.albertineapp.com/app/?openApp=true"
  },
  "emailService": "revolut@albertineapp.com",
  "emailServiceName": "Albertine for Revolut",
  "calendarUserEmail": {
    "localhost": "test.concierge@albertineapp.com",
    "dev": "test.concierge@albertineapp.com",
    "staging": "test.concierge@albertineapp.com",
    "prod": "revolut@albertineapp.com"
  },
  "externalLinks": {
    "privacyPolicy": {
      "en": "https://revolut.albertineapp.com/app/privacy-policy",
      "fr": "https://revolut.albertineapp.com/app/privacy-policy?lang=fr",
      "de": "https://revolut.albertineapp.com/app/privacy-policy?lang=de"
    },
    "termsAndConditions": {
      "en": "https://revolut.albertineapp.com/app/terms-and-conditions",
      "fr": "https://revolut.albertineapp.com/app/terms-and-conditions?lang=fr",
      "de": "https://revolut.albertineapp.com/app/terms-and-conditions?lang=de"
    },
    "permissionPolicy": null
  },
  "external_link_patterns": [],
  "public_share_base_url": {
    "localhost": "http://localhost:5001/albertine-dev/europe-west1/publicShare",
    "dev": "https://concierge-revolut.dev.albertineapp.com/",
    "staging": "https://concierge-revolut.staging.albertineapp.com/",
    "prod": "https://revolut.albertineapp.com/"
  },
  "host_name": {
    "localhost": "localhost:3006",
    "dev": "concierge-revolut.dev.albertineapp.com",
    "staging": "concierge-revolut.staging.albertineapp.com",
    "prod": "revolut.albertineapp.com"
  },
  "production_domains": [
    "revolut.albertineapp.com"
  ],
  "firebase_host_names": {
    "localhost": "localhost:3006",
    "dev": "albertine-dev-concierge-revolut.firebaseapp.com",
    "staging": "albertine-staging-concierge-revolut.firebaseapp.com",
    "prod": "albertine-prod-concierge-revolut.firebaseapp.com"
  },
  "lmt": {
    "tenantName": "Revolut",
    "trialsEnabled": false
  }
};

// index.ts
var tenantConfig = {
  albertine,
  hugoboss,
  mastercard,
  carlo,
  "visa-i2": visaI2,
  revolut
};
export {
  albertine,
  carlo,
  common,
  hugoboss,
  mastercard,
  revolut,
  tenantConfig,
  visaI2
};
